import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const ImageContainer = styled(Image)`
  width: 3.438em;
  display: block;
`
const PointsTitle = styled.h5`
  color: #6ad5aa;

  font-size: 1em;
  font-weight: bold;
`
const PointsDescription = styled.p`
  color: #000000;

  font-size: 0.813em;
`

export default function PointsComponent(props) {
  const { imageSrc, title, description } = props
  return (
    <Row className="p-3">
      <Col className="col-3">
        <ImageContainer src={imageSrc} className="m-auto" />
      </Col>
      <Col className="col-9">
        <PointsTitle>{title}</PointsTitle>
        <PointsDescription>{description}</PointsDescription>
      </Col>
    </Row>
  )
}

PointsComponent.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
}
